

































import Vue from "vue";
import { bus } from "./main";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ModuleTypes } from "./store/ModuleTypes";
import { SnackbarMutationTypes } from "@/views/academy/common/snackbar/SnackbarMutationTypes";
import ActionTypes from "@/store/ActionTypes";
import GetterTypes from "@/store/GetterTypes";
import { getModule } from "vuex-module-decorators";
import IFrameModalModule from "@/store/modules/IFrameModalModule";
import TopNav from "@/components/TopNav.vue";
import iFrameModal from "@/components/common/iFrameModal.vue";
import CommonSnackbar from "@/views/academy/common/snackbar/CommonSnackbar.vue";
import TeambotTour from "@/components/TeambotTours/TeambotTour.vue";
import AutoLogout from "@/components/AutoLogout.vue";
import ExpiredSubscriptionNotification from "@/components/common/ExpiredSubscriptionNotification.vue";
import { getJiraToken } from "@/helpers/api";

const AUTH_TOKEN = "X-Auth-Token";

export default Vue.extend({
  name: "App",
  metaInfo: {
    title: "TeamBot",
    titleTemplate: s => (s == "TeamBot" ? "TeamBot" : `${s} | TeamBot`)
  },
  components: {
    ExpiredSubscriptionNotification,
    /*Loading,*/ AutoLogout,
    TopNav,
    CommonSnackbar,
    iFrameModal,
    TeambotTour
  },
  data() {
    return {
      loadingCounter: 0,
      iFrameModule: getModule(IFrameModalModule, this.$store),
      showAlertDialog: false,
      showExpiredSubscription: false
    };
  },
  created() {
    this.loadingCounter++;
    this.initGlobalState();
    this.setupGlobalEventListeners();
    this.loadingCounter--;
    // this.loginToChat();
  },
  methods: {
    // async loginToChat() {
    //   setTimeout(async () => {
    //     const token = await getJiraToken();
    //     const chatWidget = document.querySelector("chat-widget");
    //     if (!chatWidget) return;
    //     // @ts-ignore
    //     await chatWidget.loginWithToken(token);
    //
    //     // This code is the mvp to record sessions triggered by the chat window
    //     // setTimeout(() => {
    //     //   // @ts-ignore
    //     //   chatWidget.show();
    //     //
    //     //   setTimeout(() => {
    //     //     const icon = document
    //     //       .querySelector("chat-widget")
    //     //       ?.shadowRoot?.querySelector(".chat-widget-icon");
    //     //     console.log(icon);
    //     //     if (!icon) return;
    //     //     icon.addEventListener(
    //     //       "click",
    //     //       () => {
    //     //         // @ts-ignore
    //     //         console.log("loaded");
    //     //         // LogRocket.init("scsqti/teambot");
    //     //         // LogRocket.identify(user.id, {
    //     //         //     name: user.firstName + " " + user.lastName
    //     //         // });
    //     //         const interval = setInterval(() => {
    //     //           const messages = document
    //     //             .querySelector("chat-widget")
    //     //             ?.shadowRoot?.querySelectorAll(".message-bubble-html");
    //     //           let enableTrack = false;
    //     //           messages?.forEach(message => {
    //     //             if (message.innerHTML.includes("record")) {
    //     //               enableTrack = true;
    //     //             }
    //     //           });
    //     //           if (enableTrack) {
    //     //             console.log("TRACKING");
    //     //           }
    //     //           clearInterval(interval);
    //     //         }, 10000);
    //     //       },
    //     //       { once: true }
    //     //     );
    //     //   }, 1000);
    //     // }, 1000);
    //   }, 1000);
    // },
    setupGlobalEventListeners() {
      bus.$on("loadingOn", (text: string) => {
        if (this.loadingCounter === 0) {
          this.SHOW_SNACKBAR({
            text: text,
            timeout: 0,
            color: "secondary"
          });
        }
        this.loadingCounter++;
      });
      bus.$on("loadingOff", () => {
        this.loadingCounter--;
        if (this.loadingCounter === 0) {
          this.HIDE_SNACKBAR();
        }
      });
      bus.$on("errorSnack", (text: string) => {
        this.snackbarOn(text, "error darken-1");
      });
      bus.$on("successSnack", (text: string) => {
        this.snackbarOn(text, "secondary");
      });
      bus.$on("infoSnack", (text: string) => {
        this.snackbarOn(text, "secondary");
      });
      bus.$on(
        "loadIframe",
        ({
          url,
          title,
          callback
        }: {
          url: string;
          title: string;
          callback: null | Function;
        }) => {
          this.iFrameModule.showModal({
            url: url,
            title: title,
            callback: callback
          });
        }
      );
      bus.$on("closeIframe", () => {
        this.iFrameModule.hideModal();
      });
      bus.$on("showExpiredSubscription", () => {
        this.showExpiredSubscription = true;
      });
    },

    snackbarOn(text: string, color: string) {
      this.SHOW_SNACKBAR({
        text: text,
        timeout: 5000,
        color
      });
    },
    ...mapActions({
      initGlobalState: ActionTypes.INIT_GLOBAL_STATE
    }),

    ...mapActions(ModuleTypes.SNACKBAR, {
      SHOW_SNACKBAR: SnackbarMutationTypes.SHOW_SNACKBAR,
      HIDE_SNACKBAR: SnackbarMutationTypes.HIDE_SNACKBAR
    }),

    ...mapMutations(ModuleTypes.AUTH, ["setUserRoles", "setToken"]),
    ...mapActions(ModuleTypes.AUTH, ["fetchAuthToken"])
  },
  computed: {
    loading(): boolean {
      return this.loadingCounter > 0;
    },
    ...mapGetters({
      initStateLoaded: GetterTypes.GET_INIT_STATE_LOADED,
      alerts: GetterTypes.GET_ALERTS
    })
  }
});
